/*!
=========================================================
* Muse Ant Design Dashboard - v1.0.0
=========================================================
* Product Page: https://www.creative-tim.com/product/muse-ant-design-dashboard
* Copyright 2021 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/muse-ant-design-dashboard/blob/main/LICENSE.md)
* Coded by Creative Tim
=========================================================
* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/
import "../src/components/utils/axiosSetup";
import 'react-app-polyfill/ie11'; // For IE 11 support
import 'react-app-polyfill/stable';
import 'core-js';
import './polyfill';
import React from "react";
import ReactDOM from "react-dom";
import * as serviceWorker from './serviceWorker';
// import { BrowserRouter } from "react-router-dom";
import {Provider} from 'react-redux';
import { ConfigProvider } from 'antd';
import {PersistGate} from 'redux-persist/integration/react';
import {store, persister} from './store/index';
import {createRoot} from 'react-dom/client';
import faIR from 'antd/es/locale/fa_IR';
import App from "./App";


const container = document.getElementById('root');
const root = createRoot(container); // createRoot(container!) if you use TypeScript
root.render(
  <Provider store={store}>
    <ConfigProvider 
    direction="rtl" 
    locale={faIR}
    // theme={{ algorithm: theme.darkAlgorithm }}
    >
      <PersistGate loading={null} persistor={persister}>
          <App tab="home"/>
      </PersistGate>
    </ConfigProvider>
  </Provider>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
